import { AUTH_HEADER_NAME } from 'constants/constants';
import HeaderDecorator from 'decorators/HeaderDecorator/HeaderDecorator';
import { IAuthDecorator } from './interfaces/IAuthDecorator';

export default class AuthDecorator extends HeaderDecorator implements IAuthDecorator {
    private token: string = null;

    public setToken = (token: string) => {
        this.token = token;
    };

    public getHeaders = (): Record<string, string> => {
        if (this.token) {
            return {
                ...super.getHeaders(),
                [AUTH_HEADER_NAME]: `Bearer ${this.token}`,
            };
        }

        return super.getHeaders();
    };
}
